import { FETCH_CONFIGURATION } from '../actions/types';
import {
  SECTION_HORIZONTAL,
  SECTION_VERTICAL,
  PRODUCT_STYLE_GRID,
  STRIPE_API_KEY,
  GOOGLE_API_KEY
} from '../../constants';

const INITIAL_STATE = {
  companyId: null,
  secondaryColor: null,
  name: null,
  webapp: {
    images: {}
  },
  cgu: '',
  logoUrl: null,
  appleStoreId: null,
  playStoreId: null,
  orderTypes: [],
  paymentTypes: [],
  stuart: false,
  theme: null,
  sectionOrientation: SECTION_VERTICAL,
  productStyle: PRODUCT_STYLE_GRID,
  qrcode: {},
  terminal: {},
  google: {},
  stripeApiKey: null,
  landing: {},
  chatbot: {},
  servicePrice: {},
  delivery: {},
  facebook: {},
  multiOrder: false,
  disableProductInstruction: false,
  marketplace: {},
  images: {},
  imagesDescription: '',
  slotInterval: 30,
  configHours: {},
  cancel: {},
  descriptionText: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONFIGURATION:
      const { webapp, domain, google, descriptionText } = action.payload;
      const stripeApiKey = STRIPE_API_KEY(domain.includes('dev'));
      return {
        ...state,
        images: action.payload.images || {},
        secondaryColor: action.payload.secondaryColor,
        name: action.payload.name,
        companyId: action.payload.id,
        cgu: action.payload.cgu,
        imagesDescription: action.payload.imagesDescription,
        appleStoreId: action.payload.appleStoreId,
        playStoreId: action.payload.playStoreId,
        logoUrl: action.payload.logoUrl,
        webapp,
        sectionOrientation:
          (webapp && webapp.sectionOrientation) || SECTION_VERTICAL,
        productStyle: (webapp && webapp.productStyle) || PRODUCT_STYLE_GRID,
        orderTypes: action.payload.orderTypes,
        paymentTypes: action.payload.paymentTypes,
        stuart: action.payload.stuart,
        theme: action.payload.theme,
        terminal: action.payload.terminal,
        qrcode: action.payload.qrcode,
        chatbot: action.payload.chatbot || {},
        socials: action.payload.socials || {},
        slides: action.payload.slides || {},
        stripeApiKey,
        landing: (webapp && webapp.landing) || {},
        delivery: action.payload.delivery || {},
        facebook: action.payload.facebook || {},
        multiOrder: action.payload.multiOrder || false,
        google: google || {},
        disableProductInstruction: action.payload.disableProductInstruction,
        localize: action.payload.localize || {},
        servicePrice: action.payload.servicePrice || {},
        loyalty: action.payload.loyalty || {},
        marketplace: action.payload.marketplace || {},
        configHours: action.payload.hours || {},
        cancel: action.payload.cancel || {},
        descriptionText
      };
    default:
      return state;
  }
};
